import { styled } from "@mui/material";
export const Wrap = styled("div")(() => ({
    width: "100%",
    margin: "0 auto",
    paddingLeft: "32px",
    paddingRight: "32px",
    "@media (max-width: 768px)": {
        paddingLeft: "8px",
        paddingRight: "8px",
    },
}));
export const WrapTitle = styled("div")(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
}));
export const BaseCarousel = styled("div")(({ hasArrows }) => ({
    position: "relative",
    width: "100%",
    paddingLeft: hasArrows ? "24px" : "0px",
    paddingRight: hasArrows ? "24px" : "0px",
    "@media (max-width: 768px)": {
        paddingLeft: "0px",
        paddingRight: "0px",
    },
}));
export const SliderStyled = styled("div")(() => ({
    "& .slick-list": {
        padding: "20px 0px 40px 0px",
        overflow: "hidden",
        "& div": {
            margin: "auto",
        },
    },
}));
export const CustomPagingStyled = styled("div")(({ currentSlide }) => ({
    width: "12px",
    height: "12px",
    backgroundColor: currentSlide
        ? "var(--hemoes-carousel-dot-active-bg)"
        : "var(--hemoes-carousel-dot-bg)",
    border: `2px solid ${currentSlide
        ? "var(--hemoes-carousel-dot-active-border)"
        : "var(--hemoes-carousel-dot-border)"}`,
    borderRadius: "50%",
    marginTop: "-20px",
    marginLeft: "6px",
    marginRight: "6px",
    boxShadow: currentSlide
        ? "var(--hemoes-carousel-dot-active-shadow)"
        : "var(--hemoes-carousel-dot-shadow)",
    transition: "background 0.2s, border 0.2s",
    cursor: "pointer",
    "&:hover": {
        border: "2px solid var(--hemoes-carousel-dot-hover-border)",
    },
}));
export const IconButtonleft = styled("div")(() => ({
    position: "absolute",
    top: "calc(50% - 32px)",
    left: "-48px",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "64px",
    height: "64px",
    background: "var(--hemoes-carousel-arrow-bg)",
    borderRadius: "50%",
    boxShadow: "var(--hemoes-carousel-arrow-shadow)",
    cursor: "pointer",
    transition: "background 0.2s",
    "@media (max-width: 768px)": {
        display: "none",
    },
    "&:hover": {
        background: "var(--hemoes-carousel-arrow-bg-hover)",
    },
    "& button": {
        background: "transparent",
        boxShadow: "none",
        minWidth: 0,
        padding: 0,
        color: "var(--hemoes-carousel-arrow-icon)",
        fontSize: "calc(32px + var(--accessibility-font-delta, 0px))",
    },
    "& svg": {
        fontSize: "calc(32px + var(--accessibility-font-delta, 0px))",
        color: "var(--hemoes-carousel-arrow-icon)",
    },
}));
export const IconButtonRight = styled(IconButtonleft)({
    left: "auto",
    right: "-48px",
});
